export class PhpDataProvider {

    public readonly domain:   string;
    public readonly accentMap: {[key: string]: string};

    constructor() {
        // @ts-ignore - variable 'settings' is directly in the page added by koupani component
        //      www-ep-release/sys-koupani/koupani_ctrl.php.
        const data = settings;

        if (typeof data !== 'object' || typeof data.domain !== 'string' || typeof data.accentMap !== 'object') {
            throw new Error('Unable to read data needed for the frontend app.');
        }

        this.domain    = data.domain;
        this.accentMap = data.accentMap;
    }
}